import React from "react";
import { styled } from "@linaria/react";
import { color, fonts } from "@ui";
import formatDate from "@ui/i18n/formatDate";
import t from "../../i18n";
import { TimeLine } from "@ui/IconV2/react";

const LastAnalysisDateContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  margin-top: auto;
`;

const IconTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 1px;
  gap: 5px;
  font: ${fonts.body2SemiBold};
  white-space: nowrap;
`;

const LastAnalysisTitle = styled.div<{ hasLastAnalysisDate: boolean }>`
  font: ${fonts.body2};
  color: ${props => (props.hasLastAnalysisDate ? color.carbon900 : color.carbon700)};
`;

const LastAnalysisdDate = styled.div`
  font: ${fonts.body2SemiBold};
  color: ${color.carbon900};
`;

export const LastAnalysisProject = ({
  publishedAnalysesLastDate,
  timezone,
}: {
  publishedAnalysesLastDate: string | null;
  timezone: string;
}) => (
  <LastAnalysisDateContainer>
    <IconTitleContainer>
      <TimeLine color={color.carbon800} size="s" />
      <LastAnalysisTitle hasLastAnalysisDate={publishedAnalysesLastDate !== null}>
        {publishedAnalysesLastDate
          ? t("common.date.last_analysis")
          : t("common.date.no_last_analysis")}
      </LastAnalysisTitle>
    </IconTitleContainer>
    {publishedAnalysesLastDate && (
      <LastAnalysisdDate>
        {formatDate(new Date(publishedAnalysesLastDate), "date", timezone)}{" "}
      </LastAnalysisdDate>
    )}
  </LastAnalysisDateContainer>
);
